// Mint Design Tokens — mint variant
import type { ThemeDefinition } from '@vcard/shared/types';

const mintTheme: ThemeDefinition = {
  colors: {
    main: { light: '#D1F5EA', dark: '#06041F' },
    card: { light: '#ffffff', dark: '#0d0a2d' },
    surface: { light: '#A3EBD5', dark: '#13294B' },
    action: { light: '#47D7AC', dark: '#47D7AC' },
    actionHover: { light: '#3AAB94', dark: '#75E1C1' },
    confirm: { light: '#C4C9D2', dark: '#205463' },
    confirmHover: { light: '#b2b8c2', dark: '#2D807B' },
    textPrimary: { light: '#06041F', dark: '#D1F5EA' },
    textSecondary: { light: '#13294B', dark: '#A3EBD5' },
    textMuted: { light: '#205463', dark: '#C4C9D2' },
    border: { light: '#75E1C1', dark: '#205463' },
    inputBg: { light: '#ffffff', dark: '#13294B' },
  },
  borderRadius: {
    card: '40px',
    container: '25px',
    page: '1.5rem',
    button: '9999px',
    input: '0.75rem',
    badge: '6px',
    full: '9999px',
  },
  borderWidth: {
    default: '1px',
    thick: '2px',
    avatar: '6px',
    device: '8px',
  },
  textures: {
    main: {
      light: '',
      dark: '',
      size: '0',
      blendLight: 'normal',
      blendDark: 'normal',
      opacityLight: 0,
      opacityDark: 0,
    },
    surface: { light: '', dark: '', size: '', blendLight: 'multiply', blendDark: 'overlay', opacityLight: 0, opacityDark: 0 },
    card: { light: '', dark: '', size: '', blendLight: 'multiply', blendDark: 'overlay', opacityLight: 0, opacityDark: 0 },
  },
};

export default mintTheme;
